import React, { useState } from "react";
import api from "../../api/api";

export default function RiderPresence() {
  const [online, setOnline] = useState(false);

  const toggle = async () => {
    if (online) {
      await api.post("/api/rider/offline");
    } else {
      await api.post("/api/rider/online");
    }
    setOnline(!online);
  };

  return (
    <button onClick={toggle}>
      {online ? "Go Offline" : "Go Online"}
    </button>
  );
}
